// extracted by mini-css-extract-plugin
export default {"skeleton_wrapper":"LoadingComponent_skeleton_wrapper__FblSL"};